import {IntermediatePart} from "../../parts/intermediatePart";
import {Vanity} from "../../parts/vanity";

export default class VanityAccent extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "accent_wall";
    this.partName = "Accent Wall";
    this.translateId = "visualizer.bathroom.walls.accent_wall";
    this.dbName = "VanityAccent";
    this.activeFeatureBeforeAllWalls = null;
    this.selectedByUser = false;
    this.visible = true;
    this.canBeDisabled = true;
    this.allWallsApplied = false;
    this.isStoneFeature = true;
    this.disabled = false;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new VanityAccent());
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    return super.navigationSubItemsWithFilter('CountertopSize', this.getParent().layout.parts[Vanity.id].counterTopSize(), filteredAvailableFeatures);
  }

  handleClick() {
    const wallParent = this.getParent().getParent();
    const vanityParent = wallParent.layout.parts[Vanity.id];
    if (vanityParent.vanityBacksplash && vanityParent.vanityBacksplash.canBeDisabled && !vanityParent.vanityBacksplash.placeholderChanged) {
      vanityParent.vanityBacksplash.disabled = true;
    }
    super.handleClick()
  }

  // handleClick(clickFrom) {
  //   if (clickFrom === 'fromAllWalls') {
  //     if (!this.getParent().vanityAccentSelectedByUser) {
  //       super.handleClick();
  //     }
  //   } else {
  //     this.getParent().handleChildClick(this);
  //     this.getParent().vanityAccentSelectedByUser = true;
  //   }
  //
  // }

  // handleClick(clickFrom) {
  //   const parent = this.getParent();
  //   if (clickFrom === 'simpleWall' || clickFrom === 'showerWall' || clickFrom === 'vanityWall') {
  //     parent.activeFeatureBeforeAllWalls = parent.activeFeature;
  //     if (!parent.placeholderChanged) {
  //       parent.rememberToRecoverPlaceholder = true;
  //     }
  //     if (!parent.selectedByUser) {
  //       super.handleClick();
  //     }
  //   } else {
  //     super.handleClick();
  //     parent.selectedByUser = true;
  //     const wallB = this.getParent().getParent().layout.parts["Walls"]["wallB"];
  //     if (wallB.placeholderChanged && wallB.activeFeature.partName === this.partName) {
  //       parent.selectedByUser = false;
  //     }
  //   }
  //   this.featureClicked();
  // }
  //
  // unCheckAllWalls() {
  //   if (!this.selectedByUser) {
  //     const tempSelectedByUser = this.selectedByUser;
  //     if (this.activeFeatureBeforeAllWalls) {
  //       this.activeFeatureBeforeAllWalls.handleChildClick(this);
  //       this.activeFeatureBeforeAllWalls = null;
  //     }
  //     this.selectedByUser = tempSelectedByUser;
  //     if (this.rememberToRecoverPlaceholder) {
  //       this.placeholderChanged = false;
  //       this.rememberToRecoverPlaceholder = false;
  //     }
  //   }
  // }

  setDefault(layout) {
    const counterTopSize = this.getParent().layout.parts[Vanity.id].counterTopSize();
    const filteredFeatures = this.features && this.features.filter(f => f.matchesMetaForCondition('CountertopSize', counterTopSize)) || [];
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Tan Hexagon");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || super.setDefault(layout) || null;
    }
  }

  setLayers(layout) {
    const counterTopSize = this.getParent().layout.parts[Vanity.id].counterTopSize();
    if (this.activeFeature && (this.activeFeature.matchesMetaForCondition('CountertopSize', counterTopSize)
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      // this.activeFeature.layer.zIndex = Z.layouts.Large.Wall_A_Accent_Mask;
      this.activeFeature.layer.zIndex = zIndexes.Wall_A_Accent_Mask;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndexes.Wall_A_Accent_Mask;
    }
  }
}
